{
  "form_title": "Extra onderzoek",
  "short_title": "Extra onderzoek",
  "form_description": "Neem de vinkjes over zoals ze op het papieren formulier zijn gezet.",
  "validation_error": "Controleer of je antwoord gelijk is aan het papieren proces-verbaal",
  "extra_investigation_done": {
    "title": "Heeft het gemeentelijk stembureau extra onderzoek gedaan?",
    "short_title": "Extra onderzoek vanwege andere reden dan onverklaard verschil?"
  },
  "ballots_recounted_extra_investigation": {
    "title": "Zijn de stembiljetten naar aanleiding van het extra onderzoek (gedeeltelijk) herteld?",
    "short_title": "Stembiljetten na onderzoek (deels) herteld?"
  }
}
